// Capçalera de secció del disseny (c-section-head): subtítol, títol, text
// i, si n'hi ha, botó "Veure tot" a la dreta.
const CabeceraSeccion = ({ antetitulo, titulo, texto, boton, className = "" }) => (
    <div className={"c-section-head " + className + (boton ? "" : " c-section-head--not-default")}>
        <span className="c-section-head__subtitle text-uppercase color-primary">{antetitulo}</span>
        {titulo && <h2 className="c-section-head__title">{titulo}</h2>}
        {texto && <div className="c-section-head__texts" dangerouslySetInnerHTML={{ __html: texto }}></div>}
        {boton && (
            <a href={boton.href} className="c-button c-button--outline c-section-head__call-to-action c-button--large">
                {boton.label}
            </a>
        )}
    </div>
);

export default CabeceraSeccion;
